import { render, staticRenderFns } from "./ItemScLNewItem_Search.vue?vue&type=template&id=19471bb4"
import script from "./ItemScLNewItem_Search.vue?vue&type=script&lang=js"
export * from "./ItemScLNewItem_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports